export const environment = {
    production: true,
    name: 'prod',
    baseUrl: 'https://api.serasaexperian.com.br/dispute-cadastral/v1',
    accountBasePath: 'https://api.serasaexperian.com.br/cross-domain/account/v1',
    certificateBasePath: 'https://api.serasaexperian.com.br/security/iam/v1',
    personValidationPath: 'https://api.serasaexperian.com.br/person-validation/v1',
    deviceBasePath: 'https://api.serasaexperian.com.br/digital/device/v1',
    ecsBasePath: 'https://api.serasaexperian.com.br/cadastropositivo/session/v1',
    mfaBasePath: 'https://api.serasaexperian.com.br/security/iam/v1',
    logoutUrl: 'https://apigw-portal-prd.ecsbr.net/v1/user/logout',
    cepUrl: 'https://api.serasaexperian.com.br/digital/geolocation/v1/countries/BRA/zipcodes/'
};

export const features = {
    enableAuthIam: true,
    enableMFA: true,
    enablePOL: true
};

export const redirect = {
    basePath: 'https://www.serasa.com.br/dados-cadastrais/',
    serasaConsumidorLogin: 'https://serasa.com.br/entrar',
    ouvidoria: 'https://www.serasa.com.br/cadastro-positivo/ouvidoria',
    serasaConsumidorCadastro: 'https://serasa.com.br/cadastrar',
    homePath: '/dados-cadastrais/',
    faq: 'https://www.serasa.com.br/cadastro-positivo/faq',
    urlAtualizacaoDados: 'https://www.serasa.com.br/meus-dados/alterar-dados/'
};

export const clientId = {
    certificateAuthentication: '5ed12383bc49b56d675d97e2',
    disputeFront: 'Pb5Qa0MsHXj394QzYUwlB5TcbEvoHfT0',
    tokenApp: 'NWQ2NDQ1ZDA5MjIyN2YwMDA5M2I2NDk2OjU5NDZiMzkwMDBmNzIyMjkwZDU0NDZkNQ==',
    ecsClientId: 'Lj0H3UTZRZuTKkDB1MGUcIxaht72NKGF'
};
